var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRolesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12711_12274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5984 18.1998C16.7465 18.1998 19.2984 15.6478 19.2984 12.4998C19.2984 9.35178 16.7465 6.7998 13.5984 6.7998C10.4504 6.7998 7.89844 9.35178 7.89844 12.4998C7.89844 15.6478 10.4504 18.1998 13.5984 18.1998Z",
    stroke: "#CECACA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.98438 6.75C7.64123 6.75 8.98437 5.40685 8.98437 3.75C8.98437 2.09315 7.64123 0.75 5.98438 0.75C4.32752 0.75 2.98438 2.09315 2.98438 3.75C2.98438 5.40685 4.32752 6.75 5.98438 6.75Z",
    stroke: "#CECACA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13219 9.5601C7.47219 9.2601 6.74219 9.1001 5.97219 9.1001C3.08219 9.1001 0.742188 11.4401 0.742188 14.3301",
    stroke: "#CECACA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12.6215L12.5838 13.7558L15.3984 11",
    stroke: "#CECACA",
    strokeWidth: 1.26027,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12711_12274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.05,
    height: 18.95,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolesIcon);
export default __webpack_public_path__ + "static/media/rolesIcon.61ce226e22cf0939d687347b8314e761.svg";
export { ForwardRef as ReactComponent };